import cx from 'classnames';
import React from 'react';
import { Line } from 'components/common/types/Deal.types';
import { DirectSalesNavigationLineData } from 'components/common/types/DirectSalesHeader';
import { CampaignNameAndStatus } from '../CampaignDrawer/CampaignNameAndStatus/CampaignNameAndStatus';
import { DealLines } from './DealLines/DealLines';
import CampaignActionButtons from '../CampaignActionButtons';
import AddNewLineButton from './AddNewLineButton/AddNewLineButton';

interface CampaignHeaderProps {
  isCampaignDrawerOpen: boolean;
  headerContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  isOverviewMode: boolean;
  isReviewMode?: boolean;
  isAddNewLineDisabled?: boolean;
  onAddNewLineClick: VoidFunction;
  displayedLines: (Line | DirectSalesNavigationLineData)[];
  isDealLinesDropdownVisible: boolean;
  onLineSelect: (line: Line) => void;
  isSelectLineDisabled: boolean;
}

const CampaignHeaderLines: React.FC<CampaignHeaderProps> = ({
  isCampaignDrawerOpen,
  headerContainerRef,
  isOverviewMode,
  isReviewMode = false,
  isAddNewLineDisabled,
  onAddNewLineClick,
  displayedLines,
  isDealLinesDropdownVisible,
  onLineSelect,
  isSelectLineDisabled,
}) => {
  return (
    <header
      className="bg-neutral-50 border-t border-neutral-950-opacity-10 flex items-center sticky top-0 bg-white z-30"
      data-test-id="unified-header"
    >
      <div
        className={cx('border-l flex border-neutral-950-opacity-10 h-full', {
          'border-r': isCampaignDrawerOpen,
          'border-b pl-[1px]': !isCampaignDrawerOpen,
        })}
      >
        <CampaignNameAndStatus />
      </div>
      <div
        data-test-id="unified-header-lines-list"
        className="whitespace-nowrap flex flex-1 min-w-0 items-center space-x-2 py-2 px-[16px] border-b border-neutral-950-opacity-10"
        ref={headerContainerRef}
      >
        {isOverviewMode ? (
          <AddNewLineButton isDisabled={isAddNewLineDisabled} onClick={onAddNewLineClick} />
        ) : (
          <div className="min-h-[25px] flex items-center space-x-2">
            <DealLines
              displayedLines={isReviewMode ? [] : displayedLines}
              displayDealLinesDropdown={isDealLinesDropdownVisible}
              isAddNewLineDisabled={isAddNewLineDisabled}
              isSelectLineDisabled={isSelectLineDisabled}
              onLineSelect={onLineSelect}
              onAddNewLineClick={onAddNewLineClick}
            />
          </div>
        )}
      </div>
      <div className="flex items-center h-full border-b border-neutral-950-opacity-10">
        <CampaignActionButtons />
      </div>
    </header>
  );
};

export default CampaignHeaderLines;
